import { CryptoService } from './../../../../abstraction/crypto.service';
import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { CoinInfo } from '../../../../utils/cryptoCoinInfo';
import { ICryptoBundle } from 'src/app/pages/core/models/Crypto';

@Component({
  selector: 'app-basic-crypto-card',
  templateUrl: './basic-crypto-card.component.html',
  styleUrls: ['./basic-crypto-card.component.scss'],
})
export class BasicCryptoCardComponent implements OnInit {
  @Input() crypto;
  @Input() bundle: ICryptoBundle;
  @Input() isBundle = false;
  @Input() prices;
  @Input() exchangeCardOpened;
  @Input() isArsCurrency;
  @Input() bundleVariation = 0;

  isBuying = true;
  cryptoSymbol: string;
  maxDiscountApplicable = 0;
  coinBasicInfo: {
    description: string;
    url: string;
    tags: string[];
  };
  buyPrice = 0;
  sellPrice = 0;
  variation: number;

  constructor(public authService: AuthService, private cryptoService: CryptoService) {}

  ngOnInit(): void {
    if (!this.isBundle) {
      this.variation = +this.crypto.capitalChangeP;
      this.cryptoService.prices.subscribe((prices) => {
        const priceTicker = this.isArsCurrency
          ? this.crypto.ticker + '_ARS'
          : this.crypto.ticker + '_USD';
        const currentPrice = prices[priceTicker];
        this.variation = +currentPrice.variation?.daily;
      });
      if (this.crypto.currency === 0) {
        this.cryptoSymbol = this.crypto.symbol.replace('_USD', '');
      } else if (this.crypto.currency === 1) {
        this.cryptoSymbol = this.crypto.symbol.replace('_ARS', '');
      }
      this.maxDiscountApplicable = this.authService.getMaxAplicableDiscount();
      this.coinBasicInfo = CoinInfo[this.crypto.ticker];
    }
  }
}
